import { useQuery } from "@tanstack/react-query"

import {
  listMillFloorLoads,
  listMillFloorQueueLots,
  listMillFloorUsinages,
} from "@/features/mill-floor/api/mill-floor.api"
import type {
  MillFloorLoadFilter,
  UsinageBucket,
} from "@/features/mill-floor/api/types"

export const millFloorKeys = {
  all: ["mill-floor"] as const,
  loads: (status: MillFloorLoadFilter) =>
    ["mill-floor", "loads", status] as const,
  queueLots: (status: MillFloorLoadFilter) =>
    ["mill-floor", "queue-de-lots", status] as const,
  usinages: (bucket: UsinageBucket) =>
    ["mill-floor", "usinages", bucket] as const,
}

export function useMillFloorLoads(status: MillFloorLoadFilter = "all") {
  return useQuery({
    queryKey: millFloorKeys.loads(status),
    queryFn: () => listMillFloorLoads(status),
  })
}

export function useMillFloorQueueLots(status: MillFloorLoadFilter = "all") {
  return useQuery({
    queryKey: millFloorKeys.queueLots(status),
    queryFn: () => listMillFloorQueueLots(status),
  })
}

export function useMillFloorUsinages(bucket: UsinageBucket) {
  return useQuery({
    queryKey: millFloorKeys.usinages(bucket),
    queryFn: () => listMillFloorUsinages(bucket),
  })
}
